/* ==========================================================================
   Dermiq Conversion Layer — v1
   - Multi-tier reward engine (auto-add/remove gifts)
   - Sticky ATC controller
   - PDP small UX (event tracking hooks)
   ========================================================================== */
(function(){
  'use strict';

  // ── Helpers ──────────────────────────────────────────────────────────
  function $(sel, ctx){ return (ctx||document).querySelector(sel); }
  function $$(sel, ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); }
  function fmtMoney(cents){
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents, Shopify.money_format || '€{{amount}}'); } catch(e){}
    }
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var lang = (document.documentElement.lang || navigator.language || 'sv-SE').replace('_','-');
    try { return new Intl.NumberFormat(lang,{style:'currency',currency:cur}).format((cents||0)/100); } catch(e){}
    return '€' + ((cents||0)/100).toFixed(2);
  }

  function track(name, data){
    if (typeof window.dqTrack === 'function') window.dqTrack(name, data || {});
  }

  // ── Toast ────────────────────────────────────────────────────────────
  function toast(msg){
    var el = document.createElement('div');
    el.className = 'dq-toast';
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function(){ el.classList.add('is-show'); });
    setTimeout(function(){
      el.classList.remove('is-show');
      setTimeout(function(){ el.remove(); }, 400);
    }, 2200);
  }
  window.dqToast = toast;

  // ── Reward Engine ────────────────────────────────────────────────────
  // Reads cart, updates progress bar, and auto-injects/removes free gifts.
  var REWARD_LOCK = false;
  var lastUnlocked = { 1:false, 2:false, 3:false };

  function fetchCart(){
    return fetch('/cart.js', {headers:{Accept:'application/json'}}).then(function(r){return r.json();});
  }
  function changeLine(id, qty){
    return fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
      body: JSON.stringify({id:id, quantity: qty})
    }).then(function(r){return r.json();});
  }
  function addItem(variantId, props){
    return fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
      body: JSON.stringify({id:variantId, quantity:1, properties: props || {_gift:'true'}})
    }).then(function(r){return r.json();});
  }

  function isGiftLine(line){
    return line && line.properties && (line.properties._gift === 'true' || line.properties._gift === true);
  }

  function syncRewardBars(cart){
    var bars = $$('.dq-rewards');
    if (!bars.length) return;
    bars.forEach(function(bar){
      var t1 = parseInt(bar.dataset.t1,10) || 4500;
      var t2 = parseInt(bar.dataset.t2,10) || 7500;
      var t3 = parseInt(bar.dataset.t3,10) || 11000;
      var subtotal = (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price) || 0;
      // Exclude free-gift line totals from threshold check (they cost 0 anyway, so harmless, but keep)
      var pct = Math.min(100, (subtotal / t3) * 100);
      var fill = bar.querySelector('[data-rewards-fill]');
      if (fill) fill.style.width = pct + '%';

      var nodes = $$('.dq-rewards-node', bar);
      var tiers = $$('.dq-rewards-tiers li', bar);
      var unlocked = {1: subtotal >= t1, 2: subtotal >= t2, 3: subtotal >= t3};

      [1,2,3].forEach(function(t){
        var node = nodes.find(function(n){return n.dataset.tier == t;});
        var li   = tiers.find(function(n){return n.dataset.tier == t;});
        if (node) node.classList.toggle('is-unlocked', unlocked[t]);
        if (li)   li.classList.toggle('is-unlocked', unlocked[t]);
        if (unlocked[t] && !lastUnlocked[t]) {
          if (node) { node.classList.add('dq-pulse'); setTimeout(function(){ node.classList.remove('dq-pulse'); }, 800); }
          track('RewardUnlocked', { tier: t, threshold: (t===1?t1:t===2?t2:t3)/100 });
        }
      });
      lastUnlocked = unlocked;

      // Message
      var msgEl = bar.querySelector('[data-rewards-msg]');
      if (msgEl) {
        if (unlocked[3]) {
          msgEl.innerHTML = '🎁 You unlocked all rewards. Enjoy!';
        } else if (unlocked[2]) {
          msgEl.innerHTML = 'Add <strong>' + fmtMoney(t3 - subtotal) + '</strong> more for a <strong>free full-size cleanser</strong>';
        } else if (unlocked[1]) {
          msgEl.innerHTML = 'Add <strong>' + fmtMoney(t2 - subtotal) + '</strong> more for a <strong>free pouch</strong>';
        } else {
          msgEl.innerHTML = 'Add <strong>' + fmtMoney(t1 - subtotal) + '</strong> more for <strong>free shipping</strong>';
        }
      }
    });
  }

  function manageGifts(cart){
    if (REWARD_LOCK) return Promise.resolve(cart);
    var bar = $('.dq-rewards');
    if (!bar) return Promise.resolve(cart);

    var t2 = parseInt(bar.dataset.t2,10) || 7500;
    var t3 = parseInt(bar.dataset.t3,10) || 11000;
    var gift2 = parseInt(bar.dataset.gift2,10) || 0;
    var gift3 = parseInt(bar.dataset.gift3,10) || 0;
    var subtotal = cart.items_subtotal_price || cart.total_price || 0;

    var ops = [];
    var nonGiftSubtotal = (cart.items || []).reduce(function(s,l){
      return isGiftLine(l) ? s : (s + (l.line_price || (l.price * l.quantity)));
    }, 0);

    function hasGift(vid){
      return (cart.items || []).some(function(l){ return l.variant_id == vid && isGiftLine(l); });
    }
    function findGiftKey(vid){
      var line = (cart.items || []).find(function(l){ return l.variant_id == vid && isGiftLine(l); });
      return line ? line.key : null;
    }

    // Tier 2 gift
    if (gift2) {
      var qualifies2 = nonGiftSubtotal >= t2;
      var present2 = hasGift(gift2);
      if (qualifies2 && !present2) ops.push({type:'add', vid:gift2});
      else if (!qualifies2 && present2) ops.push({type:'remove', key:findGiftKey(gift2)});
    }
    // Tier 3 gift
    if (gift3) {
      var qualifies3 = nonGiftSubtotal >= t3;
      var present3 = hasGift(gift3);
      if (qualifies3 && !present3) ops.push({type:'add', vid:gift3});
      else if (!qualifies3 && present3) ops.push({type:'remove', key:findGiftKey(gift3)});
    }

    if (!ops.length) return Promise.resolve(cart);
    REWARD_LOCK = true;

    return ops.reduce(function(p, op){
      return p.then(function(){
        if (op.type === 'add')    return addItem(op.vid);
        if (op.type === 'remove' && op.key) return changeLine(op.key, 0);
      });
    }, Promise.resolve())
    .then(fetchCart)
    .then(function(c){ REWARD_LOCK = false; return c; })
    .catch(function(){ REWARD_LOCK = false; return cart; });
  }

  function refreshRewards(){
    return fetchCart().then(function(cart){
      return manageGifts(cart).then(function(c2){
        syncRewardBars(c2 || cart);
        return c2 || cart;
      });
    });
  }

  // Re-run on cart updates
  document.addEventListener('dermiq:cart:updated', refreshRewards);
  document.addEventListener('DOMContentLoaded', refreshRewards);

  // ── Sticky ATC ───────────────────────────────────────────────────────
  function initStickyATC(){
    var bar = $('#dqStickyAtc');
    var pdpForm = $('#dermiqProductForm');
    var btn = $('#dqStickyBtn');
    if (!bar || !pdpForm) return;
    document.body.classList.add('dq-has-sticky');

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) bar.classList.remove('is-visible');
        else bar.classList.add('is-visible');
      });
    }, {threshold: 0.05});
    io.observe(pdpForm);

    if (btn) {
      btn.addEventListener('click', function(){
        track('StickyATCClicked', {});
        // Submit the original form so variant + selling_plan apply.
        var submit = pdpForm.querySelector('[type="submit"]');
        if (submit) submit.click();
      });
    }
  }
  document.addEventListener('DOMContentLoaded', initStickyATC);

  // ── Toast on add-to-cart from main PDP form ─────────────────────────
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (f && f.id === 'dermiqProductForm') {
      setTimeout(function(){ toast('Added to your bag'); }, 350);
    }
  });

  // ── Track add-to-cart events globally ───────────────────────────────
  document.addEventListener('dermiq:cart:updated', function(){
    fetchCart().then(function(cart){
      if (!cart || !cart.items || !cart.items.length) return;
      var last = cart.items[cart.items.length - 1];
      track('AddToCart', {
        content_ids: [String(last.product_id)],
        content_name: last.product_title,
        value: (last.price || 0) / 100,
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    });
  });

  // Expose for other scripts
  window.dqRefreshRewards = refreshRewards;
})();
